import { call, put } from 'redux-saga/effects';

import { httpResponseCheckSaga } from 'src/store/commonSaga';
import { apiGetFrontendFeatureFlags } from 'src/api/configuration';
import { featureFlagsSlice } from 'src/store/featureFlags/slice';

export function* getFrontendFeatureFlags(): Generator {
  yield httpResponseCheckSaga(
    function* () {
      return yield call(apiGetFrontendFeatureFlags);
    },
    function* (response) {
      yield put(featureFlagsSlice.actions.getFlagsOk(response));
    },
    featureFlagsSlice.actions.getFlagsError
  );
}
